import { env } from '@/utils/env';

export const showDevTools = () => {
    return env.DEV || localStorage.getItem('showDevTools') === 'true';
};
